import React from 'react';
import { LiquidMetal } from '@paper-design/shaders-react';
import { cn } from '../../lib/utils';
import { useShaderViewportQuality } from '../../hooks/useShaderViewportQuality';

/** Public path works with CRA `PUBLIC_URL` (including `homepage: "."` for Electron). */
export const NAMI_LOGO_PUBLIC_URL = `${process.env.PUBLIC_URL ?? ''}/nami_logo.svg`;

export interface NamiLiquidMetalLogoProps {
  className?: string;
  wrapperClassName?: string;
  variant?: 'splash' | 'hero';
}

/**
 * NAMI wordmark with Paper liquid-metal shader. Image: `public/nami_logo.svg`.
 * Flat container — no pill outline or glow so the mark reads clean on any background.
 */
export const NamiLiquidMetalLogo: React.FC<NamiLiquidMetalLogoProps> = ({
  className,
  wrapperClassName,
  variant = 'hero',
}) => {
  const { minPixelRatio, maxPixelCount } = useShaderViewportQuality();

  const isSplash = variant === 'splash';
  const shaderScale = isSplash ? 0.82 : 0.76;

  const widthClass = isSplash
    ? 'max-w-[min(94vw,22rem)] sm:max-w-[min(92vw,28rem)] md:max-w-[min(88vw,34rem)] lg:max-w-[min(72vw,40rem)] xl:max-w-[44rem]'
    : 'max-w-[min(94vw,20rem)] sm:max-w-[min(92vw,26rem)] md:max-w-[min(90vw,30rem)] lg:max-w-[min(85vw,34rem)] xl:max-w-[36rem]';

  return (
    <div className={cn('mx-auto w-full', widthClass, wrapperClassName)}>
      <div className={cn('relative aspect-[390/100] w-full', className)}>
        <div className="absolute inset-0">
          <LiquidMetal
            speed={1}
            softness={0.8}
            repetition={3.65}
            shiftRed={0.17}
            shiftBlue={-0.31}
            distortion={0.4}
            contour={0.18}
            scale={shaderScale}
            rotation={0}
            shape="circle"
            angle={92}
            image={NAMI_LOGO_PUBLIC_URL}
            frame={63443.999999994034}
            colorBack="#00000000"
            colorTint="#76B4FF"
            fit="contain"
            minPixelRatio={minPixelRatio}
            maxPixelCount={maxPixelCount}
            style={{
              backgroundColor: 'transparent',
              borderRadius: 0,
              border: 'none',
              boxShadow: 'none',
              outline: 'none',
              width: '100%',
              height: '100%',
            }}
          />
        </div>
      </div>
    </div>
  );
};
